import { AxiosResponse, axios } from '~/modules'
import {
  HeadCircumferenceMeasurement,
  HeadCircumferenceMeasurementsFetchParams,
  HeightMeasurement,
  HeightMeasurementsFetchParams,
  WeightMeasurement,
  WeightMeasurementsFetchParams
} from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchBabyGrowthWeightMeasurements = async (
  params: WeightMeasurementsFetchParams
): Promise<WeightMeasurement[]> => {
  const { pathParam, queryParams } = params
  const response = await axios.get(`${hstoryAPI}/patients/${pathParam.patientId}/pediatric-weight-measurements`, {
    params: { ...queryParams }
  })
  const { data }: AxiosResponse<WeightMeasurement[]> = response
  return data
}

export const fetchBabyGrowthHeightMeasurements = async (
  params: HeightMeasurementsFetchParams
): Promise<HeightMeasurement[]> => {
  const { pathParam, queryParams } = params
  const response = await axios.get(`${hstoryAPI}/patients/${pathParam.patientId}/pediatric-height-measurements`, {
    params: { ...queryParams }
  })
  const { data }: AxiosResponse<HeightMeasurement[]> = response
  return data
}

export const fetchBabyGrowthHeadMeasurements = async (
  params: HeadCircumferenceMeasurementsFetchParams
): Promise<HeadCircumferenceMeasurement[]> => {
  const { pathParam, queryParams } = params
  const response = await axios.get(
    `${hstoryAPI}/patients/${pathParam.patientId}/pediatric-head-circumference-measurements`,
    {
      params: { ...queryParams }
    }
  )
  const { data }: AxiosResponse<HeadCircumferenceMeasurement[]> = response
  return data
}
